// extracted by mini-css-extract-plugin
export default {"button":"ThemeToggle_button__wJtBs","image":"ThemeToggle_image__mPZvW"};